export default function Heroku() {
  return (
    <>
      <svg
        width="138"
        height="39"
        viewBox="0 0 138 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden md:block"
      >
        <title>Heroku</title>
        <path
          d="M31.396.122H3.862A3.44 3.44 0 00.408 3.576v31.468a3.44 3.44 0 003.454 3.453h27.534a3.44 3.44 0 003.454-3.453V3.576A3.44 3.44 0 0031.396.122zm1.535 34.922c0 .863-.671 1.535-1.535 1.535H3.862a1.515 1.515 0 01-1.535-1.535V3.576c0-.864.672-1.535 1.535-1.535h27.534c.864 0 1.535.671 1.535 1.535v31.468zM9.043 32.74l4.317-3.837-4.317-3.838v7.675zM24.585 17.2c-.768-.767-2.207-1.727-4.605-1.727-2.59 0-5.277.672-7.196 1.343V5.878H8.947v16.598l2.686-1.247s4.413-2.015 8.25-2.015c1.92 0 2.4 1.055 2.4 2.015V32.74h3.837V21.23c.096-.288.096-2.399-1.535-4.03zM19.5 12.114h3.837c1.727-2.014 2.59-4.03 2.879-6.236h-3.838c-.384 2.207-1.343 4.222-2.878 6.236zm106.012 9.019V12.69h3.837v8.443c0 1.918.672 2.878 2.207 2.878 1.535 0 2.111-.864 2.111-2.878V12.69h3.741v8.539c0 3.741-1.823 5.948-5.948 5.948-4.125-.096-5.948-2.303-5.948-6.044zm-16.118-8.443h3.838v5.18l3.933-5.18h4.413l-4.797 5.564 5.181 8.635h-4.317l-3.358-5.66-1.055 1.247v4.413h-3.838V12.69zm-18.228 7.004c0-5.181 3.55-7.388 7.003-7.388 3.454 0 7.004 2.207 7.004 7.388 0 5.18-3.55 7.387-7.004 7.387-3.453 0-7.003-2.11-7.003-7.387zm10.073 0c0-2.59-1.151-4.222-3.166-4.222-2.014 0-3.165 1.631-3.165 4.222 0 2.59 1.15 4.317 3.165 4.317s3.166-1.631 3.166-4.317zm-25.52-7.004h5.565c3.646 0 5.852 1.247 5.852 4.605 0 2.207-.959 3.55-2.782 4.125l2.974 5.469H83.3l-2.782-4.893H79.46v4.893H75.72V12.69zm5.47 6.332c1.534 0 2.302-.48 2.302-1.631s-.672-1.631-2.303-1.631h-1.63v3.262h1.63zM61.04 12.69h10.17v3.166h-6.332v2.303h4.509v2.974h-4.51v2.59h6.62v3.07H61.042V12.69zm-17.365 0h3.838v5.277h4.7V12.69h3.839v14.199h-3.838v-5.756h-4.701v5.756h-3.838V12.69z"
          fill="#fff"
        />
      </svg>

      <svg
        width={40}
        height={40}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="md:hidden"
      >
        <path
          d="M23.633 36.33V18.102s1.185-4.361-14.604 1.785C9 19.965 9 3.032 9 3.032L14.159 3v10.85s14.445-5.69 14.445 4.314V36.33h-4.971zm2.94-26.764H21.1c1.97-2.408 3.753-6.534 3.753-6.534h5.658s-.968 2.689-3.938 6.534zM9.093 36.298v-10.38l5.191 5.19-5.19 5.19z"
          fill="#fff"
        />
      </svg>
    </>
  );
}
